import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=2f93fb4a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=2f93fb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f93fb4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f93fb4a')) {
      api.createRecord('2f93fb4a', component.options)
    } else {
      api.reload('2f93fb4a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=2f93fb4a&scoped=true&", function () {
      api.rerender('2f93fb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JVRjTY8s7QsL/JS/comp/CookieBox.vue"
export default component.exports